const componentModules = [
  ['quick-add-component, quick-add-dialog', '@theme/quick-add'],
  ['cart-discount-component', '@theme/cart-discount'],
  ['variant-picker', '@theme/variant-picker'],
  ['product-card', '@theme/product-card'],
  ['product-form-component, add-to-cart-component, sticky-add-to-cart', '@theme/fly-to-cart'],
  ['accordion-custom', '@theme/accordion-custom'],
  ['deferred-media, product-model', '@theme/media'],
  ['product-price', '@theme/product-price'],
  ['product-sku-component', '@theme/product-sku'],
  ['product-inventory', '@theme/product-inventory'],
  ['show-more-component', '@theme/show-more'],
  ['slideshow-component', '@theme/slideshow'],
  ['layered-slideshow-component', '@theme/layered-slideshow'],
  ['anchored-popover-component', '@theme/anchored-popover'],
  ['floating-panel-component', '@theme/floating-panel'],
  ['video-background-component', '@theme/video-background'],
  ['quantity-selector-component', '@theme/component-quantity-selector'],
  ['rte-formatter', '@theme/rte-formatter'],
  ['volume-pricing', '@theme/volume-pricing'],
  ['price-per-item', '@theme/price-per-item'],
  ['sticky-add-to-cart', '@theme/sticky-add-to-cart'],
];

const modulePromises = new Map();

function loadModule(specifier) {
  if (!modulePromises.has(specifier)) {
    modulePromises.set(
      specifier,
      import(specifier).catch((error) => {
        modulePromises.delete(specifier);
        console.error(`Unable to load theme component module: ${specifier}`, error);
      })
    );
  }

  return modulePromises.get(specifier);
}

function containsSelector(root, selector) {
  if (root instanceof Element && root.matches(selector)) return true;

  if (root instanceof Document || root instanceof DocumentFragment || root instanceof Element) {
    return Boolean(root.querySelector(selector));
  }

  return false;
}

function loadComponents(root = document) {
  componentModules.forEach(([selector, specifier]) => {
    if (containsSelector(root, selector)) loadModule(specifier);
  });
}

loadComponents();

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => loadComponents(node));
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });
